import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import styled from '@emotion/styled';
import { OrderResponse } from '@models/order/orderLog';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useOrderCancelable from './hooks/useOrderCancelable';
import useReOrder from './hooks/useReOrder';

interface Props {
    orderLog: OrderResponse;
}

function OrderFooter({ orderLog }:Props) {
    const { t } = useTranslation('orderLog');
    const { orderNo } = orderLog;
    const { reOrder, reOrderEnabled } = useReOrder(orderLog);
    const cancelable = useOrderCancelable(orderLog);
    const { push } = useFlow();
    return (
        <Column fullWidth spacing={5}>
            <Row spacing={2} fullWidth>
                {cancelable && (
                    <FooterButton variant='tone'
                        onClick={() => push('CancelOrderModal', { orderNo })} >
                        {t('footer.cancel')}
                    </FooterButton>
                )}
                <FooterButton disabled={!reOrderEnabled}
                    onClick={reOrder} >
                    {t('footer.reorder')}
                </FooterButton>
            </Row>
        </Column>
    );
}

const FooterButton = styled(Button)`
    flex: 1;
    padding: 0;
`;

export default OrderFooter;
